import { pipe } from 'ramda';
import { useCallback, useMemo, useState, useEffect } from 'react';
import { Just, Nothing } from 'core/maybe';
import { on } from 'core/result';
import { unreachable } from 'utils/unreachable';
import { formatterWithMinutes } from './formatter';
const stringValue = (state)=>{
    switch(state[0]){
        case 'just':
            return formatterWithMinutes(state[1]);
        case 'editing':
            return state[1];
        default:
            return undefined;
    }
};
export const getMinutes = (state)=>{
    switch(state[0]){
        case 'just':
        case 'nothing':
            return state;
        case 'editing':
            return state[3];
        default:
            return Nothing();
    }
};
export const getError = (state)=>{
    switch(state[0]){
        case 'just':
        case 'nothing':
            return Nothing();
        case 'editing':
            switch(state[2][0]){
                case 'ok':
                    return Nothing();
                case 'error':
                    return Just(state[2][1]);
                default:
                    return Nothing();
            }
        default:
            return Nothing();
    }
};
export const useInputDuration = (minutes = Nothing(), parser)=>{
    const [state, setState] = useState(minutes);
    const justMinutesProps = getMinutes(minutes);
    const valueMinutesProps = justMinutesProps[0] === 'just' ? justMinutesProps[1] : 0;
    const _minutesState = minutes[0];
    // Memoize the parser to avoid unnecessary re-renders
    const memoizedParser = useMemo(()=>parser, [
        parser
    ]);
    useEffect(()=>{
        setState((oldValue)=>{
            const minutesInUI = getMinutes(oldValue);
            const valueMinutesState = minutesInUI[0] === 'just' ? minutesInUI[1] : 0;
            if (valueMinutesState === valueMinutesProps) {
                return oldValue;
            }
            if (_minutesState === 'nothing') {
                return oldValue;
            }
            return valueMinutesProps === 0 ? Nothing() : Just(valueMinutesProps);
        });
    }, [
        valueMinutesProps,
        _minutesState
    ]);
    const handleChange = useCallback((ev)=>pipe(()=>{
            var _ev_target_value;
            return (_ev_target_value = ev.target.value) !== null && _ev_target_value !== void 0 ? _ev_target_value : null;
        }, (x)=>[
                x,
                memoizedParser(x)
            ], ([x, result])=>setState([
                'editing',
                x,
                result,
                state[0] === 'editing' ? state[3] : state
            ]))(), [
        state,
        setState,
        memoizedParser
    ]);
    const handlePressEnter = useCallback((_)=>{
        switch(state[0]){
            case 'just':
            case 'nothing':
                break;
            case 'editing':
                pipe(()=>state[2], on((m)=>setState(Just(m)), ()=>setState(state[3])))();
                break;
            default:
                unreachable(state);
        }
    }, [
        state,
        setState
    ]);
    const handleBlur = useCallback((_)=>{
        switch(state[0]){
            case 'just':
            case 'nothing':
                break;
            case 'editing':
                pipe(()=>state[2], on((m)=>setState(Just(m)), ()=>setState(state[3])))();
                break;
            default:
                unreachable(state);
        }
    }, [
        state,
        setState
    ]);
    return {
        value: stringValue(state),
        handleChange,
        handlePressEnter,
        handleBlur,
        state
    };
};
